import { UnauthorizedError, UnexpectedError } from '../errors';

import { USER_DATA_URL } from '@/constants';
import { UserEntity } from '@/types';
import { HttpStatusCode, fromBff, httpClient } from '@/utils';

export const loadUserService = async (): Promise<UserEntity> => {
  const httpResponse = await httpClient.get(fromBff(USER_DATA_URL));

  switch (httpResponse.status) {
    case HttpStatusCode.ok:
      return httpResponse.body.data;

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    default:
      throw new UnexpectedError();
  }
};
